export default {
  meta: {
    title: '鱼你在一起定制PDF'
  }
};
